import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface LocationCardFieldsProps {
  children: React.ReactNode;
}

const FieldGroups = styled(Box)(({ theme }) => ({
  gridArea: "fields",
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: 10,
  marginTop: 12,
  alignSelf: "start",
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
}));

/**
 * Container for `LocationCard.FieldGroup` children: stacked on mobile,
 * side by side from `sm`.
 */
const LocationCardFields = ({ children }: LocationCardFieldsProps) => (
  <FieldGroups>{children}</FieldGroups>
);

export default LocationCardFields;
